import { actionTypes } from '../actions/idx_admin_log.ac'

const initialState = {
  error: null,
  logs: null,
  isFetching: false
}

export const idxAdminLogs = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCHING_IDX_ADMIN_LOGS:
      return {
        ...state,
        isFetching: true
      }

    case actionTypes.RECEIVED_IDX_ADMIN_LOGS:
      return {
        ...state,
        error: null,
        isFetching: false,
        logs: action.data
      }

    case actionTypes.FAILED_FETCHING_IDX_ADMIN_LOGS:
      return {
        ...state,
        error: true,
        logs: null,
        isFetching: false
      }

    default:
      return state
  }
}
